import createError from './createError';

export const parseRequestResponse = (response, from) => {
  if (response.ok) {
    return response.body;
  } else {
    createError(response, from);
  }
};

export const getUrl = (target) => {
  let hostname = document.location.hostname;
  const protocol = document.location.protocol;

  hostname = hostname.replace(/^review\./, '');
  hostname = hostname.replace(/dev-test/, 'dev');

  if (hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
    return 'http://localhost';
  }

  if (target === 'ehe') {
    if (hostname.includes('dev')) {
      hostname = hostname.replace(/^dev\./, 'dev.ehe.');
      return `${protocol}//api.${hostname}`;
    }

    return `${protocol}//api.ehe.${hostname}`;
  }

  return `${protocol}//${target}.ocr.${hostname}`;
};

export const parseFilters = (filters) => {
  try {
    let params = '';
    Object.keys(filters).forEach((filter) => {
      if (filter === 'sortable') {
        if (filters.sortable)
          params += `orderBy=${filters[filter].replace('-', ':')}&`;
      } else if (
        filter.includes('project') ||
        filter.includes('pid') ||
        filter.includes('used') ||
        filter.includes('docket_number') ||
        filter.includes('prm_number') ||
        filter.includes('model') ||
        filter.includes('id')
      ) {
        if (filters[filter] !== '') params += `${filter}=${filters[filter]}&`;
      } else {
        params += `${filter}=like:${filters[filter]}&`;
      }
    });
    return params;
  } catch (e) {
    console.error(e);
  }
};

export const getQueryData = (page, size, filters) => {
  const queryPage = `page=${page || 1}`;
  const querySize = `size=${size || 5}`;
  const queryFilters = filters ? parseFilters(filters) : undefined;
  return `?${queryPage}&${querySize}${
    queryFilters ? '&'.concat(queryFilters) : ''
  }`;
};
